export default {
  primary: {
    backgroundColor: 'black',
    color: 'light',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontFamily: 'body',
    fontWeight: 'bold',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: ['0.9rem', '', '1rem'],
    padding: '1rem',
    ':hover': {
      backgroundColor: 'tertiary'
    }
  },
  secondary: {
    backgroundColor: '#584c00',
    color: 'primary',
    border: 'solid 2px',
    borderColor: 'primary',
    borderRadius: '0px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    fontSize: ['0.9rem', '', '1rem'],
    fontFamily: 'body',
    ':hover': {
      backgroundColor: 'primary',
      color: 'white'
    }
  }
}
